import { queryBuilder } from '~/api';

export const deleteTutorial = async (tutorialId: number): Promise<void> => {
  await queryBuilder('DELETE', `resources/tutorials/${tutorialId}`);
  return;
};
